import React, { useCallback, useEffect, useState } from "react";
import { API } from "../../shared/api/Api";
import { useSelector } from "react-redux";
import { selectUserInformations } from "../../features/authSlice";
import UserTable from "../../components/Tables/UserTable";
import axios from "axios";
import { showToast } from "../../utils/utils";

const DEBOUNCE_DELAY = 700;

const UserPage = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loader, setLoader] = useState(true);
  const [reFetchData, setReFetchData] = useState(false);
  const [orderBy, setOrderBy] = useState("created_at");
  const [orderDir, setOrderDir] = useState("DESC");

  const user = useSelector(selectUserInformations);

  const fetchUsers = useCallback(async () => {
    setLoader(true);
    try {
      const { data } = await axios.get(API.Users.app_users_allUsers, {
        params: {
          page: currentPage,
          search: debouncedSearch,
          orderBy: orderBy,
          orderDir: orderDir,
        },
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });

      if (data.status === 200 && data.errorCode === 0) {
        setUsers(data.data.items);
        setCurrentPage(data.data.current_page);
        setTotalPages(data.data.last_page);
      } else {
        showToast("Oops, Something went wrong", data.message, "error");
      }
    } catch (error) {
      showToast(
        "Oops, Something went wrong",
        error.response?.data?.message ||
          "There is an error, please try again later",
        "error"
      );
    } finally {
      setLoader(false);
      setReFetchData(false);
    }
  }, [currentPage, debouncedSearch, user.token, orderBy, orderDir]); // Ensure all dependencies

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setCurrentPage(1);
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(handler);
  }, [search]);

  // Sorting handler
  const handleSort = (column, direction) => {
    setOrderBy(column);
    setOrderDir(direction);
  };

  useEffect(() => {
    setUsers([]);
    fetchUsers();
  }, [reFetchData, fetchUsers]);

  return (
    <div className="min-h-screen p-2 sl:pt-0 sm:p-2 md:p-4 sl:p-6">
      <UserTable
        users={users}
        currentPage={currentPage}
        totalPages={totalPages}
        onSearchChange={setSearch}
        onPageChange={setCurrentPage}
        loader={loader}
        setReFetchData={setReFetchData}
        onSort={handleSort}
        currentOrderBy={orderBy}
        currentOrderDir={orderDir}
      />
    </div>
  );
};

export default UserPage;
